import { Navigate } from "react-router-dom";
import { supabase } from "../../supabase";
import { useEffect, useState } from "react";

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      setAuthenticated(!!session);
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) return null; // or loader

  return authenticated ? children : <Navigate to="/login" replace />;
}

export default ProtectedRoute;
